import { addSeconds, endOfDay, format, setMilliseconds, startOfDay, subDays } from "date-fns";
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'select' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { call, put, select } from "redux-saga/effects";

import { DateFormat } from "constants/date";
import { ReportType } from "constants/reports/report-type";
import { ApiManager } from "services/api";
import { serializeFilters } from "services/api/report/report-serializer";
// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'selectLoggedInAgent' is declared but its value is... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { selectLoggedInAgent } from "store/entities/agents";
import { IActionWithPayload } from "store/helper";

import { ReportActions } from "../actions";
import { IFetchReportPayload } from "../interfaces";

import { parseHeatmapResponse } from "./helpers";

const heatmapFetching = {
  [ReportType.NewTicketsHeatmap]: "fetchNewTickets",
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* heatmapDataFetching(action: IActionWithPayload<string, IFetchReportPayload>): any {
  const { payload } = action;
  const { reportType, filters, distribution, source } = payload;
  // @ts-expect-error TS(2345): Argument of type 'ReportDistribution | undefined' ... Remove this comment to see the full error message
  const serializedFilters = serializeFilters(filters, distribution, []);

  const dateFrom = format(startOfDay(subDays(new Date(), 6)), DateFormat.ISO);
  const dateTo = format(setMilliseconds(addSeconds(endOfDay(new Date()), 1), 0), DateFormat.ISO);

  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const response = yield call(ApiManager.reportApi[heatmapFetching[reportType]], {
    ...serializedFilters,
    dateFrom,
    dateTo,
    heatmap: true,
  });

  if (response.result) {
    yield put(
      ReportActions.fetchSuccess({
        data: parseHeatmapResponse(response.result),
        source,
        reportType,
      })
    );
  } else {
    const errorMessage = response.error && response.error.message;
    yield put(ReportActions.fetchFailure({ error: errorMessage, reportType }));
  }
}
